import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Box,
} from "@mui/material";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

const ReschedulePost = () => {
  const { postId } = useParams();
  const { userId } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
      window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch existing post
  useEffect(() => {
    if (!postId || !userId) return;

    axios
      .post(`${API_URL}/posts/detail/`, { postId, userId })
      .then((res) => {
        const dt = res.data.selected_date_and_time;
        setSelectedDateTime(dt ? dt.slice(0, 16) : ""); // "YYYY-MM-DDTHH:mm"
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert(err.response?.data?.error || "Failed to load post");
      });
  }, [postId, userId]);

  const handleSubmit = async () => {
    if (!selectedDateTime) return alert("Please select a date and time");

    try {
      const res = await axios.put(`${API_URL}/posts/reschedule/`, {
        postId,
        userId,
        selected_date_and_time: selectedDateTime,
      });

      alert("Post rescheduled successfully!");
      navigate(-1);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to reschedule post");
    }
  };

  if (!postId || !userId || loading) return <p>Loading...</p>;

  return (
    <div>
      <Header1 />
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, mt: 5 }}>
          <Typography variant="h3" fontWeight="bold" mb={3} textAlign="center">
            Reschedule Post
          </Typography>

          <TextField
            label="Select Date & Time"
            type="datetime-local"
            fullWidth
            value={selectedDateTime}
            onChange={(e) => setSelectedDateTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 3 }}
          />

          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              fullWidth
            >
              Save Changes
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              fullWidth
            >
              Cancel
            </Button>
          </Box>
        </Paper>
      </Container>
      <Footer2 />
    </div>
  );
};

export default ReschedulePost;
